module.exports = __webpack_public_path__ + "img/liusurenyuankaohe.9fcc93b4.png";